import type { AgentTaskModel } from "@fencyai/js";
import { useAgentTasks } from "@fencyai/react";
import { useCallback } from "react";
import type { ToolResult } from "./tools";

const SEARCH_MODEL: AgentTaskModel = "anthropic/claude-sonnet-4.6";

type UseDocumentSearchProps = {
  fetchClientToken: () => Promise<{ clientToken: string }>;
};

export const useDocumentSearch = ({ fetchClientToken }: UseDocumentSearchProps) => {
  const fetchToken = useCallback(() => fetchClientToken(), [fetchClientToken]);

  const { createAgentTask } = useAgentTasks({ fetchCreateAgentTaskClientToken: fetchToken });

  return useCallback(
    async (query: string): Promise<ToolResult> => {
      const trimmed = query.trim();
      if (!trimmed) {
        return { ok: false, deviationCode: "EMPTY_QUERY", message: "Tomt søk." };
      }
      try {
        const result = await createAgentTask({
          type: "MemorySearch",
          query: trimmed,
          model: SEARCH_MODEL,
          language: "no",
          chunkLimit: 5,
          queryExpansion: { queryCount: 3 },
        });
        if (result.type !== "success") {
          return { ok: false, deviationCode: "FENCY_ERROR", message: result.error.message };
        }
        return { ok: true, data: result.response.response };
      } catch (e) {
        return { ok: false, deviationCode: "FENCY_ERROR", message: (e as Error).message };
      }
    },
    [createAgentTask],
  );
};
